import React, { useMemo, useEffect } from 'react';

import PropTypes from 'prop-types';

import { SimpleTable } from '~/components';
import { t, canURL } from '~/helpers';

import MyForm from './form';

export default function Cota({ active, toggleConfirmButton }) {
  const cota = [
    { label: 'S', value: t('s.geral.opcoes.sim') },
    { label: 'N', value: t('s.geral.opcoes.nao') },
  ];

  // permissions user URL
  const permissions = useMemo(() => canURL(), []);

  // console.log('permissions', permissions);

  useEffect(() => {
    toggleConfirmButton(false);
  }, []);

  return (
    <SimpleTable
      url="contratoscotas"
      cells={[
        {
          id: 'nomeproduto',
          label: t('s.cadastro.empresaveiculo.nomeproduto'),
        },
        {
          id: 'controlacotacontratocota',
          label: t('s.cadastro.contrato.controlacotacontratocota'),
          converter: cota,
        },
        {
          id: 'volumecontratocota',
          label: t('s.cadastro.contrato.volumecontratocota'),
        },
        {
          id: 'saldocontratocota',
          label: t('s.cadastro.contrato.saldocontratocota'),
        },
      ]}
      unique={['idcontrato', 'idproduto']}
      form={MyForm}
      onCreate={!!permissions.post_cota}
      onUpdate={!!permissions.put_cota}
      onDelete={!!permissions.delete_cota}
      title={t('s.cadastro.empresaveiculo.cota')}
      restProps={active}
      query={{
        wherefield: ['idcontrato'],
        valuewherefield: [active.idcontrato],
        typewherefield: ['EQUALS'],
      }}
    />
  );
}

Cota.propTypes = {
  active: PropTypes.objectOf(PropTypes.any).isRequired,
  toggleConfirmButton: PropTypes.func.isRequired,
};
